import { useEffect, useState } from 'react';

interface CornerBracketsProps {
  topRight?: boolean;
  bottomLeft?: boolean;
  size?: number;
  mobileSize?: number;
  className?: string;
  topRightClassName?: string;
  bottomLeftClassName?: string;
}

const CUT = 12;

export const CornerBrackets = ({
  topRight = true,
  bottomLeft = true,
  size = 80,
  mobileSize = 40,
  className = '',
  topRightClassName = 'top-4 right-4',
  bottomLeftClassName = 'bottom-4 left-4',
}: CornerBracketsProps) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth < 768);
    check();
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, []);

  const s = isMobile ? mobileSize : size;
  const cut = isMobile ? 8 : CUT;

  return (
    <>
      {topRight && (
        <div
          className={`absolute ${topRightClassName} pointer-events-none ${className}`}
          style={{ width: s, height: s }}
        >
          <div className="absolute top-0 left-0 h-px bg-primary" style={{ right: `${cut}px` }} />
          <svg
            className="absolute"
            style={{ top: '-0.5px', right: '-0.5px', width: cut + 1, height: cut + 1 }}
            viewBox={`0 0 ${cut + 1} ${cut + 1}`}
            fill="none"
          >
            <line x1="0" y1="0.5" x2={cut + 0.5} y2={cut + 1} stroke="hsl(290 46% 49%)" strokeWidth="1" />
          </svg>
          <div className="absolute right-0 bottom-0 w-px bg-primary" style={{ top: `${cut}px` }} />
        </div>
      )}
      {bottomLeft && (
        <div
          className={`absolute ${bottomLeftClassName} pointer-events-none ${className}`}
          style={{ width: s, height: s }}
        >
          <div className="absolute left-0 top-0 w-px bg-primary" style={{ bottom: `${cut}px` }} />
          <svg
            className="absolute"
            style={{ bottom: '-0.5px', left: '-0.5px', width: cut + 1, height: cut + 1 }}
            viewBox={`0 0 ${cut + 1} ${cut + 1}`}
            fill="none"
          >
            <line x1="0.5" y1="0" x2={cut + 1} y2={cut + 0.5} stroke="hsl(290 46% 49%)" strokeWidth="1" />
          </svg>
          <div className="absolute bottom-0 right-0 h-px bg-primary" style={{ left: `${cut}px` }} />
        </div>
      )}
    </>
  );
};
